import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { excelStyles } from '../../components/Grid/ExcelStyles/excelStyles';
import TotalRow from '../../components/Grid/CellRenderer/TotalRow';
// import Checkbox from '../StudyList/CellRenderers/Checkbox';
import Checkbox from './CellRenderer/AutoVisibleCheckBox';
import AttachmentOnlyCheckbox from './CellRenderer/AttachmentOnlyCheckbox';
import LoadRowsComponent from '../../helpers/LoadRowsComponent';
import {getAllClients} from '../../api/clients';


const ClientsGrid = ({
  clientsList,
  onRowClicked,
  onDeleteClicked,
  search,
  setRefresh,
  refresh,
  sort = "",
  setSort = () => {},
}) => {
  const [totalRows, setTotalRows] = useState(clientsList ? clientsList.length : 0);

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    if(clientsList){
      setTotalRows(clientsList.length)
    }
  }, [clientsList]);

  useEffect(() => {
    if(refresh){
      let refreshOptions = {}
      // if adding the first row, purge for item to properly refresh
      if (gridApi.getDisplayedRowCount() === 0) refreshOptions = { purge: true };
      gridApi.refreshServerSideStore(refreshOptions);
      setRefresh(false);
    }
  }, [gridApi, refresh, setRefresh]);

  useEffect(() => {
    if(gridApi){
      //loads in more rows while scrolling
      const dataSource = {
        getRows: params => {
          let sortParam = "";
          if(params.request.sortModel.length !== 0){
            const sortColumn = params.request.sortModel[0].colId;
            const sortWay = params.request.sortModel[0].sort;
            if(sortWay === "desc"){
              sortParam += "-";
            }
            if(sortColumn === "name"){
              sortParam += `name`
            }
            else{
              sortParam += sortColumn;
            }
          }
          if(sortParam){
            setSort(sortParam);
          }
          else{
            setSort("");
          }
          const rows = getAllClients({limit: 100, offset: params?.request.startRow, search: search, sort: sortParam})
            .then( res => {
              setTotalRows(res.count);
              params.success({
                rowData: res.results,
                rowCount: res.count
              })
              if(res.count === 0){
                gridApi.showNoRowsOverlay();
              }
            });
        }
      };
      gridApi.setServerSideDatasource(dataSource);
    }
  }, [gridApi, search, setSort, sort]);

  const deleteRow = (itemId) => {
    onDeleteClicked(itemId);
  };

  const onFilterChanged = () => {
    if (gridApi) {
      const displayedRowCount = gridApi.getDisplayedRowCount();
      setTotalRows(displayedRowCount);
    }
  };

  const cellClicked = (event) => {
    const { cellRenderer } = event.colDef;
    if (cellRenderer !== "removeRow" && cellRenderer !== 'checkbox') {
      onRowClicked(event.data);
    }
  };

  const gridOptions = {
    columnDefs: [
      {
        headerName: 'ID',
        field: 'id',
        flex: '1',
      },
      {
        headerName: 'Auto Visible',
        field: 'auto_visible',
        flex: '1',
        cellRenderer: "checkbox",
        cellRendererParams: {
          source: "auto_visible",
        },
      },
      {
        headerName: 'Attachment Only',
        field: 'only_attachment',
        flex: '1',
        cellRenderer: "attachmentOnlyCheckbox",
        cellRendererParams: {
          source: "only_attachment",
        },
      },
      {
        headerName: 'Client',
        field: 'name',
        flex: '1',
      },{
        headerName: 'Identifier',
        field: 'urlpath_prefix',
        flex: '2',
      },
      {
        headerName: 'Sponsors',
        field: 'sponsors',
        flex: '2',
      },
      {
        headerName: 'Secondary Sponsors',
        field: 'secondary_sponsors',
        flex: '2',
      },
      {
        headerName: 'Schema Name',
        field: 'schema_name',
        flex: '1',
      },
      {
        headerName: "",
        width: 40,
        cellRenderer: "removeRow",
      }
    ],
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,
      filter: true,
      enablePivot: true,
      enableCharts: false,
      enableRowGroup: true,
      filterParams: {
        clearButton: true
      },
      cellStyle: { "white-space": "normal !important" },
      autoHeight: true,
      cellClassRules: {
        oddBackground: function (params) {
          return params.rowIndex % 2 === 0;
        },
      },
    },
    excelStyles,
    frameworkComponents: {
      // studyLink: StudyLinkForeignKey,  # TODO: remove
      checkbox: Checkbox,
      attachmentOnlyCheckbox: AttachmentOnlyCheckbox,
      removeRow: ({ data }) => {
        const id = data?.id;
        return (
          <i
            className="fal fa-trash-alt"
            style={{ color: "red" }}
            onClick={() => deleteRow(id)}
          ></i>
        );
      },
      LoadRowsComponent: LoadRowsComponent,
    },
    loadingCellRenderer: 'LoadRowsComponent',
    loadingCellRendererParams :{
      loadingMessage: 'One moment please...',
    },
  };

  return (
    <Container className="ag-theme-balham">
      <AgGridReact
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        onCellClicked={event => cellClicked(event)}
        onFilterChanged={onFilterChanged}
        // rowData={rowData}
        rowModelType={'serverSide'}
        serverSideStoreType={'partial'}
        cacheBlockSize={100}
      ></AgGridReact>
      <TotalRow count={totalRows} />
    </Container>
  );
}


export default ClientsGrid;

// TODO: try to unset the height : example : UsersGrid
const Container = styled.div`
flex: 1 1 auto;
padding-bottom: 20px;
height: 600px;
`
